import type { SelectChangeEvent } from '@mui/material'
import { Button, MenuItem, Select } from '@mui/material'
import { useEditorClass } from '@tunasong/editor'
import { graphHooks } from '@tunasong/graph-lib/react'
import { Dialog } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useState } from 'react'
import { useReleaseNotes } from './release-notes.hook.js'

export interface ReleaseNotesDialogProps {}

export const ReleaseNotesDialog: FC<ReleaseNotesDialogProps> = props => {
  const {} = props
  const { releaseNotes, latestUnread, setReadVersion, isReady } = useReleaseNotes()
  const PageEditor = useEditorClass('PageEditor')

  const [selectedVersion, setSelectedVersion] = useState<string>()

  const handleClose = () => {
    if (latestUnread?.version) {
      setReadVersion(latestUnread?.version)
    }
    setSelectedVersion(undefined)
  }

  const version = selectedVersion || latestUnread?.version
  const handleVersion = (e: SelectChangeEvent<string>) => setSelectedVersion(e.target.value)

  const currentReleaseNote = releaseNotes.find(r => r.version === version)

  const { entity } = graphHooks.useEntity(currentReleaseNote?.entityId)

  // We need to set the meta tag to ready when the release notes have loaded
  // This is when isReady is set, and either currentReleaseNote is not set or entity is set
  const metaLoaded = Boolean(isReady && (!currentReleaseNote || entity))

  // Helper for the tests, we want to know if the release notes are loaded
  const metaTag = <meta name="release-notes-loaded" content={metaLoaded.toString()} />

  if (!entity) {
    return metaTag
  }

  return (
    <>
      {metaTag}
      <Dialog
        fullWidth
        maxWidth="sm"
        title="Release Notes"
        open={true}
        onClose={handleClose}
        controls={
          <Select sx={{ mx: 2 }} variant="standard" size="small" value={version} onChange={handleVersion}>
            {releaseNotes.map(r => (
              <MenuItem key={r.version} value={r.version}>
                {r.version}
              </MenuItem>
            ))}
          </Select>
        }
      >
        <PageEditor element={entity} readOnly={true} />
        <Button onClick={handleClose}>Close</Button>
      </Dialog>
    </>
  )
}
